// extracted by mini-css-extract-plugin
export default {"searchStars":"j05c6Irp","searchButton":"spWr2l5B"};